import type { UserRole } from '@/entities/auth/model/auth.types';

/**
 * 권한 순서: SYSTEM > ENGINEER > ADMINISTRATOR > STAFF > OPERATOR > PLANNER
 * (SYSTEM은 로그인 불가, 숫자 작을수록 상위)
 */
const ROLE_LEVEL: Record<UserRole, number> = {
  Engineer: 0,
  Administrator: 1,
  Staff: 2,
  Operator: 3,
  Planner: 4,
};

/**
 * viewMode가 requiredRole에 접근 가능한지 검사
 * 숫자가 작을수록 상위 권한
 */
export function hasAccess(viewMode: UserRole, requiredRole: UserRole): boolean {
  return ROLE_LEVEL[viewMode] <= ROLE_LEVEL[requiredRole];
}

/**
 * userRole 기준으로 선택 가능한 뷰 모드 목록
 * Engineer: [Engineer, Administrator, Staff, Operator, Planner]
 * Administrator: [Administrator, Staff, Operator, Planner]
 * Staff: [Staff, Operator, Planner]
 * Operator: [Operator, Planner]
 * Planner: [Planner]
 *
 * @param hasPlannerId - false이면 Planner 모드 제외 (plannerId 없으면 /my/planner 접근 불가)
 */
export function getAvailableViewModes(userRole: UserRole, hasPlannerId = true): UserRole[] {
  const levels = Object.entries(ROLE_LEVEL) as [UserRole, number][];
  const maxLevel = ROLE_LEVEL[userRole];
  let modes = levels
    .filter(([, level]) => level >= maxLevel)
    .map(([role]) => role)
    .sort((a, b) => ROLE_LEVEL[a] - ROLE_LEVEL[b]);
  if (!hasPlannerId && userRole !== 'Planner') {
    modes = modes.filter((m) => m !== 'Planner');
  }
  return modes;
}

/**
 * requiredRole보다 상위 권한만 반환 (sidebarHiddenForRoles에 의미 있게 사용 가능)
 * requiredRole 이하 권한은 애초에 항목에 접근 불가하므로 숨김 설정 무의미
 */
export function getRolesAboveRequired(requiredRole: UserRole): UserRole[] {
  const requiredLevel = ROLE_LEVEL[requiredRole];
  return (Object.entries(ROLE_LEVEL) as [UserRole, number][])
    .filter(([, level]) => level < requiredLevel)
    .map(([role]) => role)
    .sort((a, b) => ROLE_LEVEL[a] - ROLE_LEVEL[b]);
}
